import React from "react";
import moment from "moment";

import { DATE_FORMAT_FRONTEND, STATUS, DATETIME_FORMAT_FRONTEND_PDF } from "../../constants";
import "./OrderExportTemplate.scss";

const OrderExportTemplate = ({ pdf, order, setting }) => {
  const pageWidth = pdf?.internal?.pageSize?.width;
  const driverNotes = (order.logs || [])
    .map(l => l.notes)
    .filter(note => note && note.trim() !== "")
    .join("; ");

  return (
    <div className="OrderExportTemplate" style={{ width: pageWidth }}>
      <div className="content-page">
        <div className="header-section">
          <div className="header-left">
            {setting?.logo && <img src={`${setting?.logo}?v=8`} crossOrigin="anonymous" />}
            <div className="name">{setting?.name}</div>
          </div>
          <div className="header-right">
            <div className="tracking-order">TRACKING ORDER</div>
            <div className="code-order">{order?.orderCode}</div>
            <div className="status-order">{STATUS.find(s => s.code === order?.status)?.name}</div>
            <div className="date-order">
              {order?.createdAt && moment(order?.createdAt).format(DATETIME_FORMAT_FRONTEND_PDF)}
            </div>
          </div>
        </div>
        <div className="order-ref bordered-section">
          <div className="text section-title">Order Ref</div>
          <div className="value order-ref-value">{order?.orderRef}</div>
        </div>
        <div className="item">
          <div className="item-title section-title">Types</div>
          <div className="item-value">
            {order?.requiredSkills ? (
              <>
                {order.requiredSkills.map(type => (
                  <div key={type} className="Type">
                    {type}
                  </div>
                ))}
              </>
            ) : (
              "-"
            )}
          </div>
        </div>
        <div className="item">
          <div className="item-title section-title">Pickup Notes</div>
          <div className="item-value">{order.pickupNotes ?? "N/A"}</div>
        </div>
        <div className="item">
          <div className="item-title section-title">Delivery Notes</div>
          <div className="item-value">{order.deliveryNotes ?? order.notes ?? "N/A"}</div>
        </div>
        <div className="line margin-top" />
        <table className="info-table">
          <thead>
            <tr>
              <th>Delivery Date</th>
              <th>Pickup Location</th>
              <th>Delivery Location</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="value">
                  {order?.deliveryDate ? moment(order?.deliveryDate).utc().format(DATE_FORMAT_FRONTEND) : "-"}
                </div>
              </td>
              <td>
                <div>{order?.pickupName}</div>
                <div className="value">{order?.pickupAddress}</div>
                <div className="value">{order?.pickupPhone}</div>
              </td>
              <td>
                <div>{order?.deliveryName}</div>
                <div className="value">{order?.deliveryAddress}</div>
                <div className="value">{order?.deliveryPhone}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="line margin-top" />
        <div className="proof-of-delivery bordered-section">
          <div className="section-title">PROOF OF DELIVERY</div>
          <div className="content">
            <div className="photos">
              <div className="name">Photos</div>
              <div className="value">
                {order?.pods.map((pod, index) => (
                  <img key={index} src={`${order?.podUrl}/${pod}?v=8`} crossOrigin="anonymous" />
                ))}
              </div>
            </div>
            <div className="signature">
              <div className="name">Signature</div>
              <div className="value">
                {order?.signature && <img src={`data:image/jpeg;base64,${order?.signature}`} crossOrigin="anonymous" />}
              </div>
            </div>
          </div>
        </div>
        <div className="driver-notes bordered-section">
          <div className="section-title">Driver Notes</div>
          <div className="content driver-notes-content">{driverNotes ?? "N/A"}</div>
        </div>
      </div>
    </div>
  );
};

export default OrderExportTemplate;
